export const baseURL = ''

export function storePut (key: string, val: string) {
  localStorage.setItem(key, val)
}

export function storeGet (key: string): string | null {
  return localStorage.getItem(key)
}
